import React from "react"
import classNames from "classnames"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import UniversalLink from "§/src/utils/UniversalLink"

import "§/src/components/contact-modal/_contact-form.scss"
import CoutryList from "./countries.json"


import { useTranslation } from "react-i18next"
import { useForm } from "react-hook-form"

const schema = yup
  .object({
    input_1: yup.string().required(), // nome
    input_2: yup.string().required(), // cognome
    input_4: yup.string().email().required(), // email
    input_6: yup.string().required(), // telefono
    input_7: yup.string().required(), // azienda
    input_9: yup.string(), // messaggio
    input_10_1: yup.boolean().equals([true]), // checkbox
    input_11: yup.string(), // stato
    input_12: yup.string(), // regione
    input_13: yup.string(), // titolo pagina
    input_14: yup.string().required(), // città
    input_11: yup.string().required(), // country selector
    input_15: yup.string().required(), // tipo richiesta
    input_16: yup.string(), // indirizzo
  })
  .required()

const countries = CoutryList

// Request type select fields
const ContactForm = props => {

  const { t } = useTranslation()
  const {
    reset,
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      input_1: "",
      input_2: "",
      input_4: "",
      input_6: "",
      input_7: "",
      input_9: "",
      input_10_1: false,
      input_11: "",
      input_12: "",
      input_13: props.pageTitle || "",
      input_14: "",
      input_15: "",
      input_16: "",
    },
  })

  const formClass = fieldName => {
    return classNames("contact-form__form-row", {
      error: isError(fieldName),
    })
  }

  const isError = (fieldName, type) => {
    if (!type) {
      type = "required"
    }
    const error = !!errors && !!errors[fieldName]
    return error && errors[fieldName].type === type
  }

  const onSubmit = async data => {
    if (!!props.onSubmit) {
      await props.onSubmit(data)
      reset()
    } else {
      console.error(data)
      reset()
    }
  }

  const linkFormTerms = props?.formLinks?.globalFormLinks?.acfoptGlobalOptions?.acfGlobal?.termsAndConditionsLink
  const linkFormPrivacy = props?.formLinks?.globalFormLinks?.acfoptGlobalOptions?.acfGlobal?.privacyPolicyLink

  const requestType = [
    `${t("Quotazione")}`,
    `${t("Info prodotto")}`,
    `${t("Supporto tecnico")}`,
    `${t("Altro")}`,
  ]  

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-6">
        <div className={formClass("input_1")}>
          <label className="contact-form__label" htmlFor="input_1">
            {t("Nome")}*
          </label>
          <input
            className="contact-form__input"
            type="text"
            id="input_1"
            autoFocus
            {...register("input_1", { required: true })}
          />
        </div>
        {!!isError("input_1") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
      </div>
      <div className="mb-6">
        <div className={formClass("input_2")}>
          <label className="contact-form__label" htmlFor="input_2">
            {t("Cognome")}*
          </label>
          <input
            className="contact-form__input"
            type="text"
            id="input_2"
            {...register("input_2", { required: true })}
          />
        </div>
        {!!isError("input_2") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
      </div>
      <div className="mb-6">
        <div className={formClass("input_4")}>
          <label className="contact-form__label" htmlFor="input_4">
            {t("Email")}*
          </label>
          <input
            className="contact-form__input"
            type="email"
            id="input_4"
            {...register("input_4", { required: true })}
          />
        </div>
        {!!isError("input_4") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
        {!!isError("input_4", "email") && (
          <span className="contact-form__error-message">
            *{t("controllare formattazione mail")}
          </span>
        )}
      </div>
      <div className="mb-6">
        <div className={formClass("input_6")}>
          <label className="contact-form__label" htmlFor="input_6">
            {t("Telefono")}*
          </label>
          <input
            className="contact-form__input"
            type="tel"
            id="input_6"
            {...register("input_6", { required: true })}
          />
        </div>
        {!!isError("input_6") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
      </div>
      <div className="mb-6">
        <div className={formClass("input_11")}>
          <label className="contact-form__label" htmlFor="input_11">
            {t("Stato")}*
          </label>

          <select
            {...register("input_11", { required: true })}
            id="input_11"
            className="contact-form__input select-input"
            onChange={function(e){
              // setValue('input_15', e.target.value, { shouldValidate: true })
              setValue('input_11', e.target.value, { shouldValidate: true })
              }
            } // Using setValue
          >
            <option key="placeholder" value="">{t('Stato')}</option>
            { countries.map((country, index) => {
                return(
                  <option key={index} value={country}>{country}</option>
                )
              })
            }
          </select>
        </div>
        {!!isError("input_11") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
      </div>
      <div className="mb-6">
        <div className={formClass("input_14")}>
          <label className="contact-form__label" htmlFor="input_14">
            {t("Citta")}*
          </label>
          <input
            className="contact-form__input"
            type="text"
            id="input_14"
            {...register("input_14", { required: true })}
          />
        </div>
        {!!isError("input_14") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
      </div>
      <div className="mb-6">
        <div className={formClass("input_16")}>
          <label className="contact-form__label" htmlFor="input_16">
            {t("Indirizzo")}
          </label>
          <input
            className="contact-form__input"
            id="input_16"
            {...register("input_16")}
          />
        </div>
      </div>
      <div className="mb-6">
        <div className={formClass("input_7")}>
          <label className="contact-form__label" htmlFor="input_7">
            {t("Nome azienda")}*
          </label>
          <input
            className="contact-form__input"
            type="tel"
            id="input_7"
            {...register("input_7", { required: true })}
          />
        </div>
        {!!isError("input_7") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
      </div>
      <div className="mb-6">
        <div className={formClass("input_15")}>
          <label className="contact-form__label" htmlFor="input_15">
            {t("Tipo di richiesta")}*
          </label>

          <select
            {...register("input_15", { required: true })}
            id="input_15"
            className="contact-form__input select-input"
            onChange={function (e) {
              setValue("input_15", e.target.value, { shouldValidate: true })
            }} // Using setValue
          >
            <option key="placeholder" value="">
              {t("Seleziona")}
            </option>
            {requestType.map((request, index) => {
              return (
                <option key={index} value={request}>
                  {request}
                </option>
              )
            })}
          </select>
        </div>
        {!!isError("input_15") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
      </div>
      <div className="mb-6">
        <div className="contact-form__form-col">
          <label className="contact-form__label" htmlFor="input_9">
            {t("Messaggio")}
          </label>
          <textarea
            className="contact-form__input w-100"
            rows="7"
            id="input_9"
            {...register("input_9")}
          ></textarea>
        </div>
      </div>
      <div className="mb-6">
        <div className="contact-form__checkbox-row">
          <input
            type="checkbox"
            className="contact-form__checkbox"
            id="input_10_1"
            {...register("input_10_1")}
          />
          <label className="flex-grow-1 terms-privacy-form-accept" htmlFor="input_10_1">
            <UniversalLink  to={linkFormTerms} className="ms-1 me-2">{linkFormTerms[2]}</UniversalLink>
            <UniversalLink  to={linkFormPrivacy}>{linkFormPrivacy[2]}</UniversalLink>
          </label>
        </div>
        {!!isError("input_10_1", "oneOf") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
      </div>
      <input type="hidden" {...register("input_11")} />
      <input type="hidden" {...register("input_13")} />
      <div className="mb-80">
        <button
          type="submit"
          className="contact-form__submit"
          disabled={isSubmitting}
        >
          {t("Invia richiesta")}
        </button>
      </div>
    </form>
  )
}

export default ContactForm
